import type { Locale } from 'date-fns';
import { enGB, ru, uk } from 'date-fns/locale';

import type { Language } from '../api/types';

export type { Language };

export const SUPPORTED_LANGUAGES = ['ru', 'en', 'uk'] as const satisfies readonly Language[];
export const DEFAULT_LANGUAGE: Language = 'ru';

export interface LanguageMeta {
  /** Native name shown in language switchers. */
  nativeName: string;
  /** BCP-47 tag for Intl APIs. English uses en-GB: 24-hour clock, Monday-first weeks, day-month order. */
  intl: string;
  dateFns: Locale;
}

export const LANGUAGES: Record<Language, LanguageMeta> = {
  ru: { nativeName: 'Русский', intl: 'ru-RU', dateFns: ru },
  en: { nativeName: 'English', intl: 'en-GB', dateFns: enGB },
  uk: { nativeName: 'Українська', intl: 'uk-UA', dateFns: uk },
};

export function isSupportedLanguage(value: unknown): value is Language {
  return typeof value === 'string' && (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** Normalizes "ru-RU", "uk", "en-US"… to a supported language, or undefined. */
export function toSupportedLanguage(value: string | null | undefined): Language | undefined {
  const base = value?.toLowerCase().split('-')[0];
  return isSupportedLanguage(base) ? base : undefined;
}
